import React from 'react';
import { HeartHandshakeIcon } from 'lucide-react';
import { Section, Reveal } from './Section';
export function About() {
  return <Section className="bg-brand-cream" data-id="element-15">
      <Reveal className="mx-auto max-w-2xl rounded-3xl bg-brand-purple p-6 text-center text-white sm:p-8" data-id="element-16">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-white/15" data-id="element-17">
          <HeartHandshakeIcon className="h-7 w-7 text-white" data-id="element-18" />
        </div>
        <h2 className="font-display text-2xl font-extrabold sm:text-3xl" data-id="element-19">
          Sobre Karito Educa
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm font-semibold leading-relaxed text-white/85 sm:text-base" data-id="element-20">
          En Karito Educa creemos que los docentes deberían dedicar más tiempo a
          enseñar y menos tiempo a tareas repetitivas. Por eso desarrollamos
          recursos prácticos, claros y fáciles de implementar que ayudan a miles
          de maestros a organizar mejor su trabajo, optimizar sus evaluaciones y
          recuperar tiempo para lo que realmente importa.
        </p>
      </Reveal>
    </Section>;
}